import { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { usePlanContext } from "./context/planContext";
import {
  PLANS_UNAVAILABLE_COPY,
  PLANS_UNAVAILABLE_EDUCATIONAL_ITEMS,
  PLANS_UNAVAILABLE_MODE,
  PLANS_UNAVAILABLE_REDIRECT_URL,
} from "../../constants/plansUnavailable";
import {
  ZipBannerButton,
  ZipBannerButtonText,
  ZipBannerContent,
  ZipBannerHeadline,
  ZipBannerSubText,
  ZipBannerTextGroup,
  ZipBannerWrapper,
} from "./styles/components";

export default function PlansUnavailableFallback() {
  const { refetchPlans, plansLoading } = usePlanContext();
  const copy = PLANS_UNAVAILABLE_COPY;
  const mode = PLANS_UNAVAILABLE_MODE;

  useEffect(() => {
    if (mode === "redirect" && PLANS_UNAVAILABLE_REDIRECT_URL) {
      window.location.replace(PLANS_UNAVAILABLE_REDIRECT_URL);
    }
  }, [mode]);

  return (
    <ZipBannerWrapper id="plans-unavailable-fallback">
      <ZipBannerContent
        sx={{
          flexDirection: "column",
          maxWidth: "800px",
          gap: { xs: "24px", md: "32px" },
        }}
      >
        <ZipBannerTextGroup sx={{ alignItems: "center", textAlign: "center" }}>
          <ZipBannerSubText sx={{ textAlign: "center" }}>
            {copy.kicker}
          </ZipBannerSubText>
          <ZipBannerHeadline sx={{ textAlign: "center" }}>
            {copy.headline}
          </ZipBannerHeadline>
          <Typography
            sx={{
              color: "#12395D",
              fontFamily: "Inter, sans-serif",
              fontSize: { xs: "16px", md: "18px" },
              lineHeight: "140%",
              letterSpacing: "-0.15px",
              textAlign: "center",
            }}
          >
            {mode === "redirect" ? copy.redirectMessage : copy.body}
          </Typography>
          {mode !== "redirect" && (
            <ZipBannerButton
              variant="contained"
              onClick={refetchPlans}
              disabled={plansLoading}
              sx={{ alignSelf: "center" }}
            >
              <ZipBannerButtonText>{copy.ctaLabel}</ZipBannerButtonText>
            </ZipBannerButton>
          )}
        </ZipBannerTextGroup>

        {mode === "educational" && (
          <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: 2 }}>
            <Typography
              sx={{
                color: "#2372B9",
                fontFamily: "Inter, sans-serif",
                fontWeight: 600,
                fontSize: { xs: "16px", md: "18px" },
                textAlign: "center",
              }}
            >
              {copy.educationalHeadline}
            </Typography>
            <Typography
              sx={{
                color: "#12395D",
                fontFamily: "Inter, sans-serif",
                fontSize: { xs: "14px", md: "16px" },
                textAlign: "center",
              }}
            >
              {copy.educationalBody}
            </Typography>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
                gap: 2,
                mt: 1,
              }}
            >
              {PLANS_UNAVAILABLE_EDUCATIONAL_ITEMS.map((item) => (
                <Box
                  key={item.title}
                  sx={{
                    border: "1px solid #D9E6F4",
                    borderRadius: "8px",
                    p: 2,
                    textAlign: "left",
                  }}
                >
                  <Typography sx={{ color: "#2372B9", fontWeight: 600, mb: 0.5 }}>
                    {item.title}
                  </Typography>
                  <Typography sx={{ color: "#12395D", fontSize: "14px" }}>
                    {item.description}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
        )}


      </ZipBannerContent>
    </ZipBannerWrapper>
  );
}
